import React from "react";
import PropTypes from "prop-types";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Fab from "@material-ui/core/Fab";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import ViewIcon from "@material-ui/icons/Visibility";
import DriveEtaIcon from "@material-ui/icons/DriveEta";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import IconButton from "@material-ui/core/IconButton";
import SubcontactIcon from "@material-ui/icons/People";
import EmojiTransportationIcon from "@material-ui/icons/EmojiTransportation";
import BeenhereIcon from "@material-ui/icons/Beenhere";
import WorkOutlineIcon from "@material-ui/icons/WorkOutline";
import AppSettingsIcon from "@material-ui/icons/LanguageOutlined";
import ReceiptIcon from "@material-ui/icons/Receipt";
import PaymentIcon from "@material-ui/icons/Payment";
import PhoneAndroidIcon from "@material-ui/icons/PhoneAndroid";
import GavelIcon from "@material-ui/icons/Gavel";

const GridActions = ({
  id,
  module,
  open,
  actions,
  hasMenu,
  onDelete,
  onMenuClick,
  onMenuClose,
  onCuitVerification,
  anchorEl,
  contact_id,
  ...props
}) => {
  const handleClick = event => {
    onMenuClick(event, id);
  };

  const handleClose = event => {
    event.preventDefault();
    onMenuClose(event);
  };

  const handleDelete = (event, id) => {
    event.preventDefault();
    onDelete(id);
  };

  const handleCuitVerification = (event, id) => {
    event.preventDefault();
    onCuitVerification(event, id);
  };

  const handleRedirect = (event, url) => {
    event.preventDefault();
    window.location.href = url;
  };

  return (
    <React.Fragment>
      <div className="row" style={{ display: "block", textAlign: "center" }}>
        {actions.view ? (
          <Fab
            color="primary"
            aria-label="view"
            variant="extended"
            style={{ boxShadow: "none", backgroundColor: "green" }}
            fontSize="small"
            className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
            onClick={e => handleRedirect(e, actions.view.url)}
          >
            <ViewIcon fontSize="small" />
          </Fab>
        ) : (
          ""
        )}
        {actions.edit ? (
          <Fab
            color="secondary"
            aria-label="edit"
            variant="extended"
            style={{ boxShadow: "none" }}
            fontSize="small"
            className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
            onClick={e => handleRedirect(e, actions.edit.url)}
          >
            <EditIcon fontSize="small" />
          </Fab>
        ) : (
          ""
        )}
        {props.cuitVerification ? (
          <Fab
            color="secondary"
            aria-label="edit"
            variant="extended"
            style={{ boxShadow: "none" }}
            fontSize="small"
            className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
            onClick={e => handleCuitVerification(e, contact_id)}
          >
            <WorkOutlineIcon fontSize="small" />
          </Fab>
        ) : (
          ""
        )}
        {actions.vehicles ? (
          <Fab
            color="primary"
            aria-label="view"
            variant="extended"
            style={{ boxShadow: "none" }}
            fontSize="small"
            className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
            onClick={e => handleRedirect(e, actions.vehicles.url)}
          >
            <DriveEtaIcon fontSize="small" />
          </Fab>
        ) : (
          ""
        )}
        {hasMenu ? (
          <React.Fragment>
            <IconButton
              aria-label="more"
              aria-controls="long-menu"
              aria-haspopup="true"
              data-id={id}
              onClick={e => handleClick(e)}
              style={{ padding: "5px" }}
            >
              <MoreVertIcon />
            </IconButton>
            <Menu
              id="long-menu"
              anchorEl={anchorEl}
              data-id={id}
              open={open}
              onClose={e => handleClose(e)}
              PaperProps={{
                style: {
                  maxHeight: "auto",
                  width: 250,
                  padding: "5px"
                }
              }}
            >
              {actions.audit.url ? (
                <MenuItem
                  onClick={e => handleClose(e)}
                  style={{ fontSize: "0.875rem" }}
                >
                  <Fab
                    color="primary"
                    aria-label="view"
                    style={{ "box-shadow": "none" }}
                    fontSize="small"
                    className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                    onClick={e => handleRedirect(e, actions.audit.url)}
                  >
                    <VerifiedUserIcon />
                  </Fab>
                  <a
                    onClick={e => handleRedirect(e, actions.audit.url)}
                    style={{ color: "inherit", textDecoration: "none" }}
                  >
                    Auditoría
                  </a>
                </MenuItem>
              ) : (
                ""
              )}
              {actions.subcontacts.url ? (
                <MenuItem
                  onClick={e => handleClose(e)}
                  style={{ fontSize: "0.875rem" }}
                >
                  <Fab
                    color="primary"
                    aria-label="view"
                    style={{ "box-shadow": "none" }}
                    fontSize="small"
                    className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                    onClick={e => handleRedirect(e, actions.subcontacts.url)}
                  >
                    <SubcontactIcon />
                  </Fab>
                  <a
                    onClick={e => handleRedirect(e, actions.subcontacts.url)}
                    style={{ color: "inherit", textDecoration: "none" }}
                  >
                    Subcontactos
                  </a>
                </MenuItem>
              ) : (
                ""
              )}
              {actions.client_routes ? (
                <MenuItem
                  onClick={e => handleClose(e)}
                  style={{ fontSize: "0.875rem" }}
                >
                  <Fab
                    color="primary"
                    aria-label="view"
                    style={{ "box-shadow": "none" }}
                    fontSize="small"
                    className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                    onClick={e => handleRedirect(e, actions.client_routes.url)}
                  >
                    <EmojiTransportationIcon />
                  </Fab>
                  <a
                    onClick={e => handleRedirect(e, actions.client_routes.url)}
                    style={{ color: "inherit", textDecoration: "none" }}
                  >
                    Costo Valet
                  </a>
                </MenuItem>
              ) : (
                ""
              )}
              {actions.client_expenses ? (
                <MenuItem
                  onClick={e => handleClose(e)}
                  style={{ fontSize: "0.875rem" }}
                >
                  <Fab
                    color="primary"
                    aria-label="view"
                    style={{ "box-shadow": "none" }}
                    fontSize="small"
                    className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                    onClick={e =>
                      handleRedirect(e, actions.client_expenses.url)
                    }
                  >
                    <BeenhereIcon />
                  </Fab>
                  <a
                    onClick={e =>
                      handleRedirect(e, actions.client_expenses.url)
                    }
                    style={{ color: "inherit", textDecoration: "none" }}
                  >
                    Gastos habilitados
                  </a>
                </MenuItem>
              ) : (
                ""
              )}
              {actions.geodefender_fines ? (
                <MenuItem
                  onClick={e => handleClose(e)}
                  style={{ fontSize: "0.875rem" }}
                >
                  <Fab
                    color="primary"
                    aria-label="view"
                    style={{ "box-shadow": "none" }}
                    fontSize="small"
                    className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                    onClick={e =>
                      handleRedirect(e, actions.geodefender_fines.url)
                    }
                  >
                    <GavelIcon />
                  </Fab>
                  <a
                    onClick={e =>
                      handleRedirect(e, actions.geodefender_fines.url)
                    }
                    style={{ color: "inherit", textDecoration: "none" }}
                  >
                    Infracciones
                  </a>
                </MenuItem>
              ) : (
                ""
              )}
              {actions.client_charge_invoices ? (
                <MenuItem
                  onClick={e => handleClose(e)}
                  style={{ fontSize: "0.875rem" }}
                >
                  <Fab
                    color="primary"
                    aria-label="view"
                    style={{ "box-shadow": "none" }}
                    fontSize="small"
                    className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                    onClick={e =>
                      handleRedirect(e, actions.client_charge_invoices.url)
                    }
                  >
                    <PaymentIcon />
                  </Fab>
                  <a
                    onClick={e =>
                      handleRedirect(e, actions.client_charge_invoices.url)
                    }
                    style={{ color: "inherit", textDecoration: "none" }}
                  >
                    Cargos generados
                  </a>
                </MenuItem>
              ) : (
                ""
              )}
              {actions.invoices ? (
                <MenuItem
                  onClick={e => handleClose(e)}
                  style={{ fontSize: "0.875rem" }}
                >
                  <Fab
                    color="primary"
                    aria-label="view"
                    style={{ "box-shadow": "none" }}
                    fontSize="small"
                    className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                    onClick={e => handleRedirect(e, actions.invoices.url)}
                  >
                    <ReceiptIcon />
                  </Fab>
                  <a
                    onClick={e => handleRedirect(e, actions.invoices.url)}
                    style={{ color: "inherit", textDecoration: "none" }}
                  >
                    Facturas generadas
                  </a>
                </MenuItem>
              ) : (
                ""
              )}
              <MenuItem
                onClick={e => handleClose(e)}
                style={{ fontSize: "0.875rem" }}
              >
                <Fab
                  aria-label="delete"
                  variant="extended"
                  style={{ "box-shadow": "none", backgroundColor: "grey" }}
                  fontSize="small"
                  className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                  onClick={e => handleDelete(e, id)}
                >
                  <DeleteIcon fontSize="small" />
                </Fab>
                <a
                  style={{ color: "inherit", textDecoration: "none" }}
                  onClick={e => handleDelete(e, id)}
                >
                  Dar de baja
                </a>
              </MenuItem>

              {actions.mobile && actions.mobile.url ? (
                <MenuItem
                  onClick={e => handleRedirect(e, actions.mobile.url)}
                  style={{ fontSize: "0.875rem" }}
                >
                  <Fab
                    aria-label="delete"
                    variant="extended"
                    style={{ "box-shadow": "none", backgroundColor: "grey" }}
                    fontSize="small"
                    className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                    onClick={e => handleRedirect(e, actions.mobile.url)}
                  >
                    <PhoneAndroidIcon fontSize="small" />
                  </Fab>
                  <a
                    style={{ color: "inherit", textDecoration: "none" }}
                    onClick={e => handleRedirect(e, actions.mobile.url)}
                  >
                    Usuario mobile
                  </a>
                </MenuItem>
              ) : (
                ""
              )}
              {actions.dashboard && actions.dashboard.url ? (
                <MenuItem
                  onClick={e => handleRedirect(e, actions.dashboard.url)}
                  style={{ fontSize: "0.875rem" }}
                >
                  <Fab
                    aria-label="delete"
                    variant="extended"
                    style={{ "box-shadow": "none", backgroundColor: "grey" }}
                    fontSize="small"
                    className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                    onClick={e => handleRedirect(e, actions.dashboard.url)}
                  >
                    <AppSettingsIcon fontSize="small" />
                  </Fab>
                  <a
                    style={{ color: "inherit", textDecoration: "none" }}
                    onClick={e => handleRedirect(e, actions.dashboard.url)}
                  >
                    Usuario dashboard
                  </a>
                </MenuItem>
              ) : (
                ""
              )}
              {actions.providerUser && actions.providerUser.url ? (
                <MenuItem
                  onClick={e => handleRedirect(e, actions.providerUser.url)}
                  style={{ fontSize: "0.875rem" }}
                >
                  <Fab
                    aria-label="delete"
                    variant="extended"
                    style={{ "box-shadow": "none", backgroundColor: "grey" }}
                    fontSize="small"
                    className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                    onClick={e => handleRedirect(e, actions.providerUser.url)}
                  >
                    <AppSettingsIcon fontSize="small" />
                  </Fab>
                  <a
                    style={{ color: "inherit", textDecoration: "none" }}
                    onClick={e => handleRedirect(e, actions.providerUser.url)}
                  >
                    Usuario Proveedor
                  </a>
                </MenuItem>
              ) : (
                ""
              )}
            </Menu>
          </React.Fragment>
        ) : (
          ""
        )}
      </div>
    </React.Fragment>
  );
};
GridActions.defaultProps = {
  open: false,
  hasMenu: true,
  cuitVerification: false,
  contact_id: 0
};

export default GridActions;
